import { FeatureTags } from '@spazious/dollhouse-types';

import { useFeatures } from './useFeatures.js';

export type FeaturesProps = {
  children: React.ReactNode;
  features: FeatureTags | FeatureTags[];
};

export const Features: React.FC<FeaturesProps> = ({ children, features }) => {
  const { hasFeature } = useFeatures();

  return hasFeature(features) ? children : null;
};
